var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.933 7.81C14.953 4.977 11.69 3 8 3S1.047 4.978.067 7.81L0 8.003l.067.195c.98 2.832 4.242 4.81 7.933 4.81s6.953-1.978 7.933-4.81L16 8.004l-.067-.195zM8 11.814c-3.102 0-5.833-1.557-6.732-3.81C2.167 5.75 4.898 4.192 8 4.192c3.102 0 5.833 1.557 6.732 3.811-.899 2.254-3.63 3.811-6.732 3.811zm.055-6.961a3.102 3.102 0 00-3.098 3.098 3.101 3.101 0 003.098 3.097 3.101 3.101 0 003.098-3.097 3.1 3.1 0 00-3.098-3.098zm0 5.003A1.907 1.907 0 016.15 7.952c0-1.05.854-1.904 1.905-1.904 1.05 0 1.905.854 1.905 1.904 0 1.05-.854 1.905-1.905 1.905z",
    strokeWidth: 0.1
  })));
}

export default SvgIconShow;